import { render, staticRenderFns } from "./InternetIcon.vue?vue&type=template&id=d1a79a5c&"
import script from "./InternetIcon.vue?vue&type=script&lang=ts&"
export * from "./InternetIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports